import { render } from "./PagePartner.vue?vue&type=template&id=4ebecaf2"
import script from "./PagePartner.vue?vue&type=script&lang=js"
export * from "./PagePartner.vue?vue&type=script&lang=js"

import "./PagePartner.vue?vue&type=style&index=0&id=4ebecaf2&lang=css"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__